// Here we'll find the sample mock data for the media library page

import { ContentItem } from '@shared/interfaces/media.interface';
import { Playlist, PlaylistHistory, PlaylistReports } from './interfaces';

export const ITEMS: ContentItem[] = [
    {
        type: 'video',
        src: '',
        name: 'opCETauReKjMtv7u9CEa_ad3.webm',
        playlistContentId: null,
        contentId: '4a643cb6-fb84-49af-85dc-8343ff9017be',
        dealerId: 'ab896873-2688-4e98-b2be-981974dae585',
        advertiserId: '',
        hostId: '0a10dcb9-8400-4d87-a7d5-782483b939b3',
        fileName: 'opCETauReKjMtv7u9CEa_ad3.webm',
        url: 'https://n-compass-filestack.s3.amazonaws.com/',
        fileType: 'webm',
        handlerId: 'uO6ij2w5Qm6AOMsrp9cA',
        dateCreated: '2026-02-13T07:10:56',
        uuid: 'daf34ac9150ac12d433f6568d38da1d5',
        isFullScreen: 0,
        filesize: '1374483',
        thumbnail:
            'https://cdn.filestackcontent.com/ALjKIdQzT1uQvACcqMCnQz/urlscreenshot/resize=height:200/https://cdn.filestackcontent.com/uO6ij2w5Qm6AOMsrp9cA',
        previewThumbnail: null,
        seq: 0,
        frequency: null,
        parentId: null,
        duration: 53.866,
        totalPlayed: 0,
        isActive: 0,
        isConverted: 1,
        createdBy: 'dea8ced1-6ba6-4b9c-b9cc-2cd7effd9277',
        createdByName: 'Test Automation',
        ownerType: null,
        title: 'ad3.webm',
        description: null,
        classification: null,
        prefix: null,
        refDealerId: null,
        playlistContentsSchedule: null,
        playlistContentCredits: null,
        creditsEnabled: null,
        playsTotal: 0,
        durationsTotal: 0,
        feedId: null,
        isProtected: 0,
        ownerRoleId: 1,
        contentPlaysListCount: null,
        playlistContentSchedule: null,
        contentCategory: 0,
        fillerGroupName: null,
        fillerGroupId: null,
        adminOnly: null,
        fillerPlaylistId: null,
        fillerPlaylistName: null,
        dateUpdated: null,
        isMigrated: 0,
        screenTemplateZonePlaylists: null,
        templateZones: null,
        isDeleted: false,
        deletedReason: null,
    },
    {
        type: 'video',
        src: '',
        name: 'SvL8j6pRZq2z85PyaeDC_ad1.webm',
        playlistContentId: null,
        contentId: '471e0f86-509c-4917-91de-9ec083991159',
        dealerId: 'ab896873-2688-4e98-b2be-981974dae585',
        advertiserId: '',
        hostId: '0a10dcb9-8400-4d87-a7d5-782483b939b3',
        fileName: 'SvL8j6pRZq2z85PyaeDC_ad1.webm',
        url: 'https://n-compass-filestack.s3.amazonaws.com/',
        fileType: 'webm',
        handlerId: 'mgH1mCYPQ1ar4QvO9d9D',
        dateCreated: '2026-02-13T07:10:55',
        uuid: 'fa4e7b45b59ce580c65a7e912cebe0ba',
        isFullScreen: 0,
        filesize: '703102',
        thumbnail:
            'https://cdn.filestackcontent.com/ALjKIdQzT1uQvACcqMCnQz/urlscreenshot/resize=height:200/https://cdn.filestackcontent.com/mgH1mCYPQ1ar4QvO9d9D',
        previewThumbnail: null,
        seq: 0,
        frequency: null,
        parentId: null,
        duration: 30.986,
        totalPlayed: 0,
        isActive: 0,
        isConverted: 1,
        createdBy: 'dea8ced1-6ba6-4b9c-b9cc-2cd7effd9277',
        createdByName: 'Test Automation',
        ownerType: null,
        title: 'ad1.webm',
        description: null,
        classification: null,
        prefix: null,
        refDealerId: null,
        playlistContentsSchedule: null,
        playlistContentCredits: null,
        creditsEnabled: null,
        playsTotal: 0,
        durationsTotal: 0,
        feedId: null,
        isProtected: 0,
        ownerRoleId: 1,
        contentPlaysListCount: null,
        playlistContentSchedule: null,
        contentCategory: 0,
        fillerGroupName: null,
        fillerGroupId: null,
        adminOnly: null,
        fillerPlaylistId: null,
        fillerPlaylistName: null,
        dateUpdated: null,
        isMigrated: 0,
        screenTemplateZonePlaylists: null,
        templateZones: null,
        isDeleted: false,
        deletedReason: null,
    },
    {
        type: 'video',
        src: '',
        name: 'PqCCAT9R3y81CCprkOU3_ad2.webm',
        playlistContentId: null,
        contentId: 'f463a21a-e109-4cc4-90af-dc77d4895075',
        dealerId: 'ab896873-2688-4e98-b2be-981974dae585',
        advertiserId: '',
        hostId: '0a10dcb9-8400-4d87-a7d5-782483b939b3',
        fileName: 'PqCCAT9R3y81CCprkOU3_ad2.webm',
        url: 'https://n-compass-filestack.s3.amazonaws.com/',
        fileType: 'webm',
        handlerId: 'NPWINpMnRRCWoublu0uM',
        dateCreated: '2026-02-13T07:10:54',
        uuid: '3206eea1c2df2ea8b8074cbee39c26f3',
        isFullScreen: 0,
        filesize: '715894',
        thumbnail:
            'https://cdn.filestackcontent.com/ALjKIdQzT1uQvACcqMCnQz/urlscreenshot/resize=height:200/https://cdn.filestackcontent.com/NPWINpMnRRCWoublu0uM',
        previewThumbnail: null,
        seq: 0,
        frequency: null,
        parentId: null,
        duration: 16.984,
        totalPlayed: 0,
        isActive: 0,
        isConverted: 1,
        createdBy: 'dea8ced1-6ba6-4b9c-b9cc-2cd7effd9277',
        createdByName: 'Test Automation',
        ownerType: null,
        title: 'ad2.webm',
        description: null,
        classification: null,
        prefix: null,
        refDealerId: null,
        playlistContentsSchedule: null,
        playlistContentCredits: null,
        creditsEnabled: null,
        playsTotal: 0,
        durationsTotal: 0,
        feedId: null,
        isProtected: 0,
        ownerRoleId: 1,
        contentPlaysListCount: null,
        playlistContentSchedule: null,
        contentCategory: 0,
        fillerGroupName: null,
        fillerGroupId: null,
        adminOnly: null,
        fillerPlaylistId: null,
        fillerPlaylistName: null,
        dateUpdated: null,
        isMigrated: 0,
        screenTemplateZonePlaylists: null,
        templateZones: null,
        isDeleted: false,
        deletedReason: null,
    },
];

export const MEDIA_TABLE_DATA: ContentItem[] = [
    {
        type: 'video',
        src: '',
        name: 'SvL8j6pRZq2z85PyaeDC_ad1.webm',
        playlistContentId: null,
        contentId: '471e0f86-509c-4917-91de-9ec083991159',
        dealerId: 'ab896873-2688-4e98-b2be-981974dae585',
        advertiserId: '',
        hostId: '0a10dcb9-8400-4d87-a7d5-782483b939b3',
        fileName: 'SvL8j6pRZq2z85PyaeDC_ad1.webm',
        url: 'https://n-compass-filestack.s3.amazonaws.com/',
        fileType: 'webm',
        handlerId: 'mgH1mCYPQ1ar4QvO9d9D',
        dateCreated: '2026-02-13T07:10:55',
        uuid: 'fa4e7b45b59ce580c65a7e912cebe0ba',
        isFullScreen: 0,
        filesize: '703102',
        thumbnail:
            'https://cdn.filestackcontent.com/ALjKIdQzT1uQvACcqMCnQz/urlscreenshot/resize=height:200/https://cdn.filestackcontent.com/mgH1mCYPQ1ar4QvO9d9D',
        previewThumbnail: null,
        seq: 0,
        frequency: null,
        parentId: null,
        duration: 30.986,
        totalPlayed: 0,
        isActive: 0,
        isConverted: 1,
        createdBy: 'dea8ced1-6ba6-4b9c-b9cc-2cd7effd9277',
        createdByName: 'Test Automation',
        ownerType: null,
        title: 'ad1.webm',
        description: null,
        classification: null,
        prefix: null,
        refDealerId: null,
        playlistContentsSchedule: null,
        playlistContentCredits: null,
        creditsEnabled: null,
        playsTotal: 0,
        durationsTotal: 0,
        feedId: null,
        isProtected: 0,
        ownerRoleId: 1,
        contentPlaysListCount: null,
        playlistContentSchedule: null,
        contentCategory: 0,
        fillerGroupName: null,
        fillerGroupId: null,
        adminOnly: null,
        fillerPlaylistId: null,
        fillerPlaylistName: null,
        dateUpdated: null,
        isMigrated: 0,
        screenTemplateZonePlaylists: null,
        templateZones: null,
        isDeleted: false,
        deletedReason: null,
    },
];

export const PLAYLIST_REPORTS_REPORTS_DATA: PlaylistReports[] = [
    {
        id: '1',
        hostName: 'hostname-1',
        playlist: 'playlist-1',
        totalPlay: 100,
        totalDuration: 1000,
        startDate: '2024-01-01',
        endDate: '2024-01-31',
    },
    {
        id: '2',
        hostName: 'hostname-2',
        playlist: 'playlist-2',
        totalPlay: 200,
        totalDuration: 2000,
        startDate: '2024-02-01',
        endDate: '2024-02-29',
    },
    {
        id: '3',
        hostName: 'hostname-3',
        playlist: 'playlist-3',
        totalPlay: 300,
        totalDuration: 3000,
        startDate: '2024-03-01',
        endDate: '2024-03-31',
    },
];

export const PLAYLIST_REPORTS_PLAYLIST_DATA: Playlist[] = [
    {
        playlistId: '123',
        playlistName: 'Sample Playlist',
        businessName: 'Mind your own',
    },
    {
        playlistId: '124',
        playlistName: 'Sample Playlist 2',
        businessName: 'Mind your own',
    },
    {
        playlistId: '125',
        playlistName: 'Sample Playlist 3',
        businessName: 'Mind your own',
    },
];

export const PLAYLIST_REPORTS_PLAYING_WHERE_DATA: PlaylistHistory[] = [
    {
        id: '1',
        playlistId: '123',
        playlistName: 'Sample Playlist',
        businessName: 'Mind your own',
        logAction: 'Added',
        logUser: 'John Doe',
        logDate: '2024-01-01',
    },
];

export const PLAYLIST_REPORTS_HISTORY_DATA: PlaylistHistory[] = [
    {
        id: '1',
        playlistId: '123',
        playlistName: 'Sample Playlist',
        businessName: 'Mind your own',
        logAction: 'Added',
        logUser: 'John Doe',
        logDate: '2024-01-01',
    },
    {
        id: '2',
        playlistId: '124',
        playlistName: 'Sample Playlist 2',
        businessName: 'Mind your own',
        logAction: 'Updated',
        logUser: 'Jane Doe',
        logDate: '2024-02-01',
    },
];
